export default __webpack_public_path__ + "64209731af378d2e622b5b296c9dd8ab.png";